import { UseQueryOptions } from '@tanstack/react-query';
import {
	getPasswordSettingsPath,
	PasswordSettings,
	savePasswordSettingsPath,
	SystemSettingConfig,
	urlCombine,
} from 'ihub/common';
import {
	coreAPI,
	getTenantID,
	handleResponse,
	standardGet,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';
import HttpResponseOptions from '../interface/http-response-options';
import QueryClientWrapper from '../utils/create-query-client';

export class SystemSettingsHttpService {
	getPasswordSettings(): UseQueryOptions<PasswordSettings, Error, PasswordSettings> {
		return {
			queryKey: [getTenantID(), SystemSettingConfig.name, getPasswordSettingsPath],
			queryFn: async (): Promise<PasswordSettings> => {
				const url = urlCombine(coreAPI, SystemSettingConfig.name, getPasswordSettingsPath);
				const res = await standardGet(url);
				await validateOkResponse(res, 'get password settings', 'Password Settings');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	async savePasswordSettings(passwordSettings: PasswordSettings, options?: HttpResponseOptions) {
		const url = urlCombine(coreAPI, SystemSettingConfig.name, savePasswordSettingsPath);
		const response = await standardPost(url, passwordSettings);
		await handleResponse(response, 'save password settings', PasswordSettings.name, options);
		await this.invalidateGetPasswordSettings();
	}

	async invalidateGetPasswordSettings() {
		await QueryClientWrapper.InvalidateKey(
			[getTenantID(), SystemSettingConfig.name, getPasswordSettingsPath],
			false
		);
	}
}
